import React, { useState, useEffect } from 'react'   
import { Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap'

import WarehouseDocksTable from './WarehouseDocksTable'
import NewWarehouseDockForm from './NewWarehouseDockForm'

import { getWarehouseDocks } from '../services'
import { handleError } from '../../../helpers'

export default function WarehouseDocksModal({ visible, onClose, warehouse, reload }) {
    const [warehouseDocks, setWarehouseDocks] = useState(null)
    const [shouldReload, setShouldReload] = useState(false)

    useEffect(() => {
        !warehouseDocks && getWarehouseDocks({ 
            'filter[warehouse_id]': warehouse.id,
            include: 'appointmentsCount'
        })
            .then(res => setWarehouseDocks(res.data.data))
            .catch(error => handleError(error))
    }, [ warehouseDocks, warehouse ])

    const handleClose = () => {
        shouldReload && reload()
        onClose()
    }

    const handleReload = () => {
        setShouldReload(true)
        setWarehouseDocks(null)
    }

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={handleClose} size='lg'>
				<ModalHeader toggle={handleClose}>Muelles de Bodega #{warehouse.sku}</ModalHeader>
				<ModalBody>
                    { warehouseDocks ? (
                        <>
                            <WarehouseDocksTable 
                                warehouseDocks={warehouseDocks} 
                                reload={handleReload} 
                            />
                            <NewWarehouseDockForm 
                                warehouse={warehouse} 
                                reload={handleReload} 
                            />
                        </>
                    ) : (
                        <Spinner />
                    )}
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}